import * as React from 'react';
import { styled } from '@linaria/react';

import useIsOnscreen from '@/hooks/use-is-onscreen';

function Instructions({ isDismissed }: { isDismissed: boolean }) {
  const [hasBeenRevealed, setHasBeenRevealed] = React.useState(false);
  const wrapperRef = React.useRef<HTMLDivElement>(null);

  const isVisible = !isDismissed && hasBeenRevealed;

  const isOnscreen = useIsOnscreen(wrapperRef);

  React.useEffect(() => {
    if (hasBeenRevealed) {
      return;
    }

    if (isOnscreen) {
      window.setTimeout(() => {
        setHasBeenRevealed(true);
      }, 1500);
    }
  }, [hasBeenRevealed, isOnscreen]);

  return (
    <div ref={wrapperRef}>
      <Wrapper
        aria-hidden="true"
        style={{
          opacity: isVisible ? 1 : 0,
          clipPath: isVisible
            ? 'polygon(0 0, 100% 0, 100% 100%, 0 100%)'
            : 'polygon(0 0, 100% 0, 100% 0, 0 0)',
          transform: isVisible
            ? 'translate(-50%, 0)'
            : 'translate(-50%, -16px)',
          pointerEvents: isVisible ? 'all' : 'none',
          transition: isDismissed
            ? 'none'
            : 'opacity 400ms, clip-path 800ms, transform 800ms',
        }}
      >
        <img
          src="/images/use-deferred-value/instructions.png"
          alt=""
        />
        <Arrow
          viewBox="0 0 168 103"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.50584 2.54776C5.53222 1.1673 4.43452 0.0268345 3.05406 0.000456283C1.6736 -0.0259219 0.533128 1.07178 0.50675 2.45224L5.50584 2.54776ZM164.431 102.999C165.811 103.037 166.961 101.949 166.999 100.569L167.62 78.0775C167.658 76.6973 166.57 75.5476 165.19 75.5095C163.809 75.4714 162.66 76.5594 162.622 77.9396L162.07 97.932L142.078 97.3803C140.697 97.3423 139.548 98.4302 139.51 99.8104C139.471 101.191 140.559 102.34 141.94 102.378L164.431 102.999ZM0.50675 2.45224C0.121542 22.6114 5.79995 34.7939 16.2098 42.4656C26.3305 49.9243 40.5712 52.7959 56.3362 55.4649C88.1905 60.8578 128.089 65.6598 162.684 102.218L166.316 98.7817C130.412 60.8402 88.8137 55.8922 57.1708 50.5351C41.1872 47.8291 28.1793 45.0757 19.1761 38.4406C10.462 32.0186 5.14105 21.6386 5.50584 2.54776L0.50675 2.45224Z"
            fill="white"
          />
        </Arrow>
      </Wrapper>
    </div>
  );
}
const Wrapper = styled.div`
  position: absolute;
  left: calc(50% - 128px);
  bottom: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  transform: translate(-50%, 0);
  pointer-events: none;

  img {
    width: 217.5px;
    aspect-ratio: 435 / 104;
    transform: rotate(-5deg);
  }

  /*
    The instructions spill off the screen on mobile.
    Rather than come up with some hacky option, we'll just hide the instructions, since they're probably superfluous anyway.
  */
  @media (max-width: 32rem) {
    display: none;
  }
`;

const Arrow = styled.svg`
  width: 84px;
  aspect-ratio: 168 / 103;
  transform: translateX(55%);
`;

export default Instructions;
